// 库存中心定制界面
export default () => ({
  CUS_SG_C_PERCENT_STRATEGY_VIEW: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/CUS_SG_C_PERCENT_STRATEGY_VIEW.vue'
    ),
    labelName: t('执行百分比分货')
  },
  CUS_SG_B_STO_TRANSFER_IN_DISTRIBUTION: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/CUS_SG_B_STO_TRANSFER_IN_DISTRIBUTION.vue'
    ),
    labelName: t('调拨入库分货')
  },
  // 出库通知单==>生成出库拣货单==>出库拣货单
  OUTBOUNDPICKORDER: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/orderCenter/scanIn/outboundPickOrder.vue'),
  },
  // 库存同步队列表
  SGCHANNELSYNSTOCKQUERY: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/sgChannelSynstockQuery.vue'),
  },
  // 库存计算缓存池/库存策略计算缓存池
  SGCHANNELSTORAGEBUFFER: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/sgChannelStorageBuffer.vue'),
  },
  // 平台店铺库存变动流水
  SGSTORAGECHANGEFTPQUERY: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/sgStorageChangeFtpQuery.vue'),
  },
  // 库存计算缓存池/库存策略计算缓存池
  SGCHANNELSTORAGEBUFFERPROCEDURE: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/sgChannelStorageBuffer.vue'),
  },
  // 共享池库存梯度策略 - 列表
  SYNCGRADIENTSTRATEGYLIST: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/syncGradientStrategy/syncGradientStrategyList.vue'),
    labelName: t('共享池库存梯度策略')
  },
  // 共享池库存梯度策略-单对象
  // SYNCGRADIENTSTRATEGY: {
  //   component: () => import(
  //     /* webpackChunkName: 'InventoryCenterModal' */
  //     'allpages/inventoryCenter/syncGradientStrategy/syncGradientStrategy.vue'),
  //   labelName:  t('共享池库存梯度策略')
  // },
  // 配销仓库存梯度策略-单对象
  SYNCGRADIENTSTRATEGY: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/syncGradientStrategySA/syncGradientStrategySA.vue'),
    labelName: t('配销仓库存梯度策略'),
  },
  // 寻源策略定义-单对象
  SOURCSTRATEGYDETAIL: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/sourcstrategy/sourcstrategyAdd.vue'),
    labelName: t('寻源策略定义')
  },
  // 指定商品比例同步策略-单对象
  CHANNELSKUSTRATEGY: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/channelSkuStrategy.vue'),
    labelName: t('指定商品比例同步策略编辑')
  },
  // 比例同步策略-单对象
  CHANNELRATIOSTRATEGY: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/channelRatioStrategy.vue'),
    labelName: t('比例同步策略编辑')
  },
  // 客户寻源策略-单对象
  CUSTOMERFINDSOURCESTRATEGY: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/customerSourcingStrategy/customerSourcingStrategy.vue'),
    labelName: t('客户寻源策略编辑')
  },
  // 店仓评分 - 列表
  STORESCORESTRATEGY: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/storeScoreStrategy/storeScoreStrategy.vue'),
    labelName: t('店仓评分设置表')
  },
  // 店仓评分 - 详情
  STORESCORESTRATEGYDETAIL: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/storeScoreStrategy/storeScoreStrategyAdd.vue'),
    labelName: t('店仓评分设置表')
  },
  // 渠道库存管理
  CHANNELSTOCKCONTROL: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/channelStockControl/channelStockControl.vue'),
    labelName: t('渠道库存管理')
  },
// 配销仓调拨单 - 商品明细Tab
  SHARESATRANSFER: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/logicalTransferOrder/logicalTransferOrderDetail.vue'),
  },
  // 分货退货单 - 商品明细Tab
  SHAREALLOCATIONRETURN: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/logicalTransferOrder/logicalTransferOrderDetail.vue'),
  },
  // 分货单 - 商品明细Tab
  SHAREALLOCATION: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/logicalTransferOrder/logicalTransferOrderDetail.vue'),
  },
  // 逻辑解冻单 - 商品明细Tab
  STOUNFREEZE: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/logicalTransferOrder/logicalTransferOrderDetail.vue'),
    labelName: t('逻辑解冻单')
  },
  // 库存调整单 - 商品明细Tab
  STOADJUST: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/logicalTransferOrder/logicalTransferOrderDetail.vue'),
  },
  // 共享调整单 - 商品明细Tab
  SHAREADJUST: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/logicalTransferOrder/logicalTransferOrderDetail.vue'),
  },
  // 门店预售活动 - 商品明细Tab
  STOREPRESALE: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/logicalTransferOrder/logicalTransferOrderDetail.vue'),
  },
  // 逻辑冻结单 - 商品明细Tab
  STOFREEZE: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/logicalTransferOrder/logicalTransferOrderDetail.vue'),
  },
  // 逻辑调拨单
  LOGICALTRANSFER: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/logicalTransferOrder/logicalTransferOrderDetail.vue')
  },
  // 寻源策略定义 - 列表
  SOURCSTRATEGY: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/sourcstrategy/sourcstrategy'),
    labelName: t('寻源策略定义')
  },
  // 其他入库单 - 商品明细Tab
  TAB_SG_B_STO_OTHER_DELIVERY: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/logicalTransferOrder/logicalTransferOrderDetail.vue')
  },
  // 其他出库单 - 商品明细Tab
  SG_B_STO_OTHER_OUT_RESULT: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/logicalTransferOrder/logicalTransferOrderDetail.vue')
  },
  // 配销仓库存梯度策略 - 列表
  SYNCGRADIENTSTRATEGYSALIST: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/syncGradientStrategySA/syncGradientStrategySAList'),
    labelName: t('配销仓库存梯度策略'),
  },
  PROFIT: { // 盘点单》盈亏按钮
    labelName: t('预盈亏'),
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/profit'
      )
  },
  // 逻辑层管理 - 多渠道调拨单
  MULTICHANNELTRANSFER: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/multiChannelTransferOrder/multiChannelTransferOrder'),
    labelName: t('多渠道调拨单')
  },

  // 聚合仓调拨单、配销仓调拨、聚合仓到配销仓调拨单、配销仓到聚合仓调拨单-定制tab( 调拨结果单据详情 )
  TRANSFERRESULTDETAIL: {
    component: () => import(
      /* webpackChunkName: 'InventoryCenterModal' */
      'allpages/inventoryCenter/transferResultDetail/transferResultDetail'),
  },

});
